import Glide from '@glidejs/glide';
import ssm from 'simplestatemanager';

class glideLoader {
    
    constructor() {
        this.initSettings();
        document.addEventListener('DOMContentLoaded', () => {
            Array.from(document.querySelectorAll('[data-glide]')).forEach((el) => {
                try {
                    var slider;
                    ssm.addState({
                        id: "mobile" + el.id,
                        query: "(max-width: 992px)",
                        onEnter: function() {
                            var slides = Array.from(el.querySelectorAll('.glide__slide'));
                            if(slides.length > 0) {
                                var initialSlide = slides.findIndex(item => {
                                    return item.classList.contains('active');
                                });
                                slider = new Glide(el, getTypeSettings(el.dataset.glideType, initialSlide));
                                let indexMovingOut;
                                let indexMovingIn;
                                slider.on('run.before', (move) => {
                                    indexMovingOut = slider.index;
                                }).on('run', (move) => {
                                    indexMovingIn = slider.index;
                                    slides[indexMovingOut].classList.add('out');
                                    slides[indexMovingIn].classList.add('in');
                                }).on('run.after', (move) => {
                                    slides[indexMovingOut].classList.remove('out');
                                    slides[indexMovingIn].classList.remove('in');
                                });
                                el.classList.remove('glide-disabled');
                                slider.mount();
                            
                            }

                            function getTypeSettings(type, initialSlide) {
                                const settings = {
                                    'mobile': {
                                        type: 'carousel',
                                        startAt: initialSlide && initialSlide >=0 ? initialSlide : 0,
                                        perView: 1,
                                        peek: 120,
                                        gap: 15,
                                        breakpoints: {
                                            650: {
                                                peek: 100,
                                            },
                                            400: {
                                                peek: 60,
                                            }
                                        }
                                    }
                                };
                                return settings[type];
                            }
                        },
                        onLeave: function() {
                            el.classList.add('glide-disabled');
                            slider.destroy()
                        }
                      });
                } catch (e) { console.error('Error', e); }

            });
        });
    }

    initSettings() {
        
    }

   
}
window.app.add('glide', new glideLoader());